import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { OpenPickPointForm } from 'sections/PromoSection/pages/PromoPage/shared/OpenPickPointForm/OpenPickPointForm'
import { TextPromo } from 'components/ui'
import { Title } from 'components/ui/Title/Title'
import { useResize } from 'utils/hooks/useResize'

import { PromoPageKeys } from '../../../types'

import s from './LoginPageGe.module.scss'

export const LoginPageGe: FC = () => {
  const { isDesktop, isMobile } = useResize()
  const { t } = useTranslation()
  
  const getKey = (key: string) => `${PromoPageKeys.loginPage}.${key}`

  return (
    <main className={s.LoginPage}>
      <div className={s.titleWrapper}>
        <Title color="white" fontWeight={700} className={s.title}>
          {t(getKey('Добро пожаловать'))}
        </Title>
        <TextPromo fontFamily="ASLHauss" size={isDesktop ? 's24' : isMobile ? 's16' : 's20'} color="white">
          {t(getKey('Зарегистрируйтесь, чтобы подать заявку'), { nbsp: '\u00A0' })}
        </TextPromo>
      </div>
      <div className={s.box}>
        <OpenPickPointForm />
      </div>
    </main>
  )
}
